<div class="[ flex gap-m w-full ]">
  <div class="[ max-w-s min-w-2xs w-1/2 max-h-full overflow-x-auto ] [ border-ie ]">
    <campus-toc-select
      [parentCollapseOnly]="true"
      [toc]="filteredTocTree$ | async"
      [selectedTocId]="selectedEduContentTocId"
      (clickToc)="selectTOC($event)"
      >
    </campus-toc-select>
  </div>
  <div class="[ grow ] [ p-m ]">
    @if (currentGroupedEvaluationSubjects$ | async; as currentGroupedEvaluationSubjects) {
      @if (showGoalWarning$ | async) {
        <div
          class="[ flex items-center ][ p-2xs m-be-m ][ border border-warn corner-s ][ body-small text-warn ]"
          >
          <div class="[ shrink-0 ][ p-ie-2xs ]"><campus-icon svgIcon="warning"></campus-icon></div>
          <div>
            Voor deze onderwerpen hebben we geen digitaal materiaal.
            @if (!readOnly) {
              <br />Vink het onderwerp af indien je dit onderwerp in de volgende stap niet wenst te zien.
            }
          </div>
        </div>
      }
      @for (evaluationSubjectGroup of currentGroupedEvaluationSubjects; track trackById($index, evaluationSubjectGroup)) {
        <div>
          <div class="[ stack gap-3xs ] [ m-be-l overflow-visible ]" data-cy="evaluation-subject-group">
            <div class="[ flex gap-m items-center ]">
              <dcr-checkbox
                #groupCheckbox
                (change)="onGroupSelectionChange(groupCheckbox, evaluationSubjectGroup)"
                [checked]="selectedHeaders[evaluationSubjectGroup.id]?.checked"
                [indeterminate]="selectedHeaders[evaluationSubjectGroup.id]?.partiallyChecked"
                [disabled]="readOnly"
                data-cy="checkbox-evaluation-subject-group"
                >
              </dcr-checkbox>
              <span class="[ title-small ]" data-cy="evaluation-subject-group-title">{{
                evaluationSubjectGroup.name
              }}</span>
            </div>
            @for (evaluationSubject of evaluationSubjectGroup.evaluationSubjects; track trackById($index, evaluationSubject)) {
              <div
                class="[ cluster ]"
                >
                <div class="[ border corner-s ][ flex flex-nowrap justify-between ]" data-cy="evaluation-subject">
                  <dcr-checkbox
                    #itemCheckbox
                    (change)="onItemSelectionChange(itemCheckbox, evaluationSubject.id, evaluationSubjectGroup)"
                    [checked]="!!selectedEvaluationSubjects[evaluationSubject.id]"
                    [disabled]="readOnly"
                    data-cy="checkbox-evaluation-subject"
                    [label]="evaluationSubject.displayOrder + '. ' + evaluationSubject.description"
                    >
                  </dcr-checkbox>
                  @if (evaluationSubject.goalIds.length === 0) {
                    <campus-icon
                      class="[ shrink-0 ][ text-warn ][ m-is-2xs ]"
                      svgIcon="warning"
                      data-cy="evaluation-subject-warning"
                    ></campus-icon>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      }
    }
  </div>
</div>
